import { render, staticRenderFns } from "./Need.vue?vue&type=template&id=2b7f0bd8&scoped=true&"
import script from "./Need.vue?vue&type=script&setup=true&lang=js&"
export * from "./Need.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f0bd8",
  null
  
)

export default component.exports